import { createFileRoute, redirect } from '@tanstack/react-router'
// import { CustomerInvoicesPage } from '@/features/customer/pages/invoices'

/** Invoices are temporarily disabled; redirect manual URL access to home. */
export const Route = createFileRoute('/_authenticated/customer/invoices')({
  // component: CustomerInvoicesPage,
  beforeLoad: () => {
    throw redirect({ to: '/customer', replace: true })
  },
})
